exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Pr3GRVMsdVpM-NggOYrLc {\n\tfloat: left;\n\twidth: 100%;\n\tdisplay: inline-block;\n}\n.LZXNp271KHE9PRfN0jPs4 {\n\tdisplay: inline-block;\n\tfloat: left;\n\twidth: 100%;\n}\n@media (min-width: 900px) {\n\t.Pr3GRVMsdVpM-NggOYrLc {\n\t\twidth: 55%;\n\t}\n\t.LZXNp271KHE9PRfN0jPs4 {\n\t\twidth: 45%;\n\t}\n}", ""]);

// exports
exports.locals = {
	"leftColumn": "Pr3GRVMsdVpM-NggOYrLc",
	"rightColumn": "LZXNp271KHE9PRfN0jPs4"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules!./~/postcss-loader!./src/styles/electrify.css
// module id = 485
// module chunks = 0